import React from "react";

export interface UIStore {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

const emptySetErrors = (_errors: boolean): void => {
  return;
};

const initialStore: UIStore = {
  showModal: false,
  setShowModal: emptySetErrors,
};

const UIContext = React.createContext<UIStore>(initialStore);

export default UIContext;
